import { useQuery } from "react-query";
import { getStates } from "src/utils/api/roles";

export const useStateOptions = () => {
  const STALE_TIME = 24 * 60 * 60 * 1000;

  const { data, isFetching } = useQuery(["getStatesType"], () => getStates(), {
    staleTime: STALE_TIME,
    cacheTime: STALE_TIME,
    refetchOnMount: false,
  });

  return {
    states: data?.data ?? [],
    isFetching,
  };
};

export default useStateOptions;
